<template>
  <v-row class="posts-list" justify="center">
    <v-col cols="12">
      <v-row no-gutters justify="center">
        <v-col class="posts-list__wrapper">
          <div class="min-h">
            <v-row class="mx-0" v-if="loaded">
              <v-col cols="12" class="w-100 d-flex align-center pb-0 px-0">
                <v-text-field
                  v-model="postsSearchInputValue"
                  class="posts-list__search-field"
                  :label="$t('message.posts.list.searchFieldPlaceholder')"
                  prepend-inner-icon="icon-search"
                  clearable
                  outlined
                  rounded
                  :hide-details="true"
                  @input="onPostsSearch"
                ></v-text-field>
                <div class="posts-list__deleted-toggle">
                  <ui-switch
                    v-model="showDeleted"
                    @change="handleChange({ page: 1 })"
                  />
                  <span>{{
                    $t("message.posts.list.toogleShowDeletedPosts")
                  }}</span>
                </div>
                <div class="ml-3">
                  <DateRangePicker
                    v-model="date"
                    @change="handleChange({ page: 1 })"
                  />
                </div>
              </v-col>

              <v-col class="py-2 px-0">
                <Pagination
                  :page="page"
                  :per-page="perPage"
                  :options="perPageOptions"
                  :total-count="totalCount"
                  :disabled="loading.list"
                  @change="handleChange"
                ></Pagination>
              </v-col>
            </v-row>
            <v-row
              class="posts-list__list-wrapper"
              v-if="loaded && posts.length > 0"
            >
              <PostListItem
                v-for="post in posts"
                :key="post.id"
                :post="post"
                :gmb-insights="insightsData[post.id] || null"
                class="posts-list__item"
                @deletePost="deletePost"
              />
              <SectionLoader :status="loading.list" :opacity="0.75" />
            </v-row>
            <v-row v-else-if="loaded && posts.length === 0">
              <PostsListEmpty />
              <SectionLoader :status="loading.list" :opacity="0.75" />
            </v-row>
          </div>
        </v-col>
      </v-row>
      <SectionLoader :status="loading.view" :opacity="1" />
    </v-col>
  </v-row>
</template>

<script>
import PostListItem from "@/components/Posts/PostListItem/PostListItem.vue";
import SectionLoader from "@/components/Loader/SectionLoader.vue";
import Pagination from "@/components/List/Pagination";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";
import { permissionsInfo } from "@/helpers/mixins/permissions-info";
import { debounce } from "@/helpers/helpers";
import serviceHandler from "@/helpers/handlers/service";
import postsService from "@/services/gmbPosts";
import { gtmEngagement as gtmEngagementMixin } from "@/helpers/mixins/gtm-engagement";
import DateRangePicker from "@/components/ui/DateRangePicker";
import { dateRangeFilterMixin } from "@/helpers/mixins/date-range-filter";
import { videoTutorialsMixin } from "@/helpers/mixins/video-tutorials";
import PostsListEmpty from "./PostsListEmpty.vue";
import moment from "moment";
import { addPostMixin } from "@/helpers/mixins/add-post";

export default {
  name: "PostsListSent",
  components: {
    PostListItem,
    SectionLoader,
    Pagination,
    DateRangePicker,
    PostsListEmpty
  },
  mixins: [
    permissionsInfo,
    gtmEngagementMixin,
    dateRangeFilterMixin,
    videoTutorialsMixin,
    addPostMixin
  ],
  data() {
    return {
      viewTitle: this.$t("message.common.postsList"),
      menu: false,
      loading: {
        view: false,
        list: false
      },
      loaded: false,
      date: this.getStartDate(),
      insightsData: {},
      insightsDataExpirationDate: moment({
        year: 2023,
        month: 1,
        day: 28
      })
    };
  },

  async mounted() {
    this.loading.view = true;
    await this.fetchPosts();
    this.loading.view = false;
    this.mixin__setGtmEngagementTimeouts();
  },

  methods: {
    async fetchPosts() {
      const response = await serviceHandler(postsService.getPosts(this.params));

      if (response && response.results) {
        this.posts = [...response.results];
        this.totalCount = response.count;
        this.fetchPostsInsights(response.results);
      }
      this.loaded = true;
    },

    async deletePost(params) {
      this.loading.list = true;

      const response = await postsService.deletePost(params.id);

      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.POSTS_MASS_DELETE,
        num_locations: params.numLocations || null,
        post_type: params.postType || null,
        publish_date: params.publishDate || null
      });

      if (response && response.status === 204) {
        this.$notify({
          group: "default",
          type: "success",
          text: this.$t("message.posts.successfullyDeleted")
        });
        await this.fetchPosts();
      }
      this.loading.list = false;
    },

    onPostsSearch: debounce(async function() {
      this.loading.list = true;
      this.page = 1;
      await this.fetchPosts();
      this.loading.list = false;
    }, 500),

    async handleChange({ page, perPage }) {
      this.loading.list = true;
      this.page = page || this.page;
      this.perPage = perPage || this.perPage;
      await this.fetchPosts();
      this.loading.list = false;
    },

    async fetchPostsInsights(posts) {
      const localPosts = posts.filter(item =>
        moment(item.created_at).isSameOrBefore(this.insightsDataExpirationDate)
      );
      if (!localPosts.length) return;
      const response = await serviceHandler(
        postsService.getPostsInsights(posts.map(i => i.id))
      );

      if (response) {
        this.insightsData = response;
      }
    }
  }
};
</script>
